import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 12h-7l3 -3","key":"svg-0"}],["path",{"d":"M6 15l-3 -3","key":"svg-1"}],["path",{"d":"M14 12h7l-3 -3","key":"svg-2"}],["path",{"d":"M18 15l3 -3","key":"svg-3"}],["path",{"d":"M3 6v-1a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v1","key":"svg-4"}],["path",{"d":"M3 18v1a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-1","key":"svg-5"}]]

const IconViewportWide = createReactComponent('outline', 'viewport-wide', 'ViewportWide', __iconNode);

export default IconViewportWide;